// extracted by mini-css-extract-plugin
export default {"wrapperMenu":"MainPage_wrapperMenu__VwUw8","logoutIcon":"MainPage_logoutIcon__UujAg","wrapperPages":"MainPage_wrapperPages__HjPY2"};